/* 
 * 轨迹地图 
 * 描述：包括百度地图组件
 * 创建时间：2017-04-18 
 * 创建人：Shujuan Sun 
 * 修改时间：
 */
<template>
	<div v-bind:style="mapStyle" class="trackMap">
		<baidu-map class="h100pp"
			:center="mapCenter" 
			:zoom="mapZoom" 
			:scroll-wheel-zoom="true" 
			:map-click="false"
			@ready="ready"
			>			
		</baidu-map>						
	</div>
</template>
<script>
	import {mapState} from 'vuex'
	import {mapGetters} from 'vuex'
	import {VEHICLE_TRACK} from 'static/constant.js'
	import {mapMixin} from 'util/util.js'
	export default {
		mixins:[mapMixin],
		name: 'TrackMap',
		props: {},
		data() {
			return {
				mapStyle: {
					width: '100%',
					height: '800px'
				},
				mapCenter:{lng: 120.39, lat: 36.073},
				mapZoom:'15',
				enableMesaureTool: false,
				temPoint:[],	//当天轨迹的坐标集合
				carLabel:'',
				carIcon:'',
				carIconName:'',
				carMarker:'',	//车辆Marker
				right:'',
				almPosi:{},		//报警现场查看时的报警点
				polyArr:[],		//单条轨迹的线集合（删除个轨迹队列时要清除对应的轨迹）
				railArr:[],		//未选中清空重绘时，地图上所有轨迹集合
				startMarker:{},
				stopMkArr:[],
				endMarker:{},
				almMarker:{},
				polyOverlay:{},
				posiM:{},//查定位点时的车辆
				targetMarker:{},	//救援点
				labelCatched:null	//已接单的label
			}
		},
		computed:{
			...mapState({
				showInfoComp:state => state.vehicle.showInfoComp,
				traceListInfo:state => state.vehicle.traceListInfo, //左侧列表
				trackId:state => state.vehicle.trackId,
				trackInfoList:state => state.vehicle.trackInfoList,//全天所有轨迹信息
				rescueEventList:state => state.vehicle.rescueEventList,//救援轨迹列表
				momentTrack:state => state.vehicle.momentTrack,//时间轴对应的轨迹信息
				mapShowType:state=>state.vehicle.mapShowType,//需要画定位点还是轨迹还是报警区域
				stopIndex:state=>state.vehicle.stopIndex,//停车点索引
				clearTheOld:state=>state.vehicle.clearTheOld, //是否开启清空重绘模式
				clearTheMap:state=>state.vehicle.clearTheMap,
				delTheChosen:state=>state.vehicle.delTheChosen,
				delTheAll:state=>state.vehicle.delTheAll,
				locateInfo:state=>state.vehicle.locateInfo,
				vehiInfo:state=>state.vehicle.vehiInfo,
				almInfoObj:state=>state.vehicle.almInfoObj,
				ballMoved:state=>state.vehicle.ballMoved,
				moveFlag:state=>state.vehicle.moveFlag
			}),
			...mapGetters([
				'travels'
			])
		},
		watch:{
			delTheChosen(val){
				if(val.length != 0){
					for(let m = 0,len = val.length; m < len; m ++){
						//TODO:删除id==val的轨迹或定位点
						for(let i = 0,len = this.railArr.length; i < len; i ++){
							if(this.railArr[i].info == val[m].id){
								if(val[m].type==1){//查定位点
									this.map.removeOverlay(this.railArr[i].marker)
								}else{
									let arrP = this.railArr[i].stopMs
									for(let k = 0,len = arrP.length; k < len; k++){
										arrP[k].hide()
									//	this.map.removeOverlay(arrP[k])
									}
									let arr = this.railArr[i].overlay
									for(let j = 0,len = arr.length; j < len; j ++){
										this.map.removeOverlay(arr[j])
									}
									this.map.removeOverlay(this.railArr[i].carM)
									this.map.removeOverlay(this.railArr[i].startM)
									this.map.removeOverlay(this.railArr[i].endM)
									if(val[m].type==2){//有报警现场和报警点
										this.map.removeOverlay(this.railArr[i].almM)
										this.map.removeOverlay(this.railArr[i].plg)
									}
									if(val[m].type == 5){//救援点
										this.map.removeOverlay(this.railArr[i].targeM)
									}
								}
							}
						}
					}
					const that = this;
					this.getBrowserPos(that.map,that.BMap)
					this.$store.dispatch('delChosen')
				}
			},
			delTheAll(val){
				if(val){
					this.map.clearOverlays()
					this.railArr = []
					const that = this;
					this.getBrowserPos(that.map,that.BMap)
				}
			},
			clearTheMap:function(val){
					//清空地图
					if(val){
						this.map.clearOverlays()
						const that = this;
						this.getBrowserPos(that.map,that.BMap)
					}
			},
			momentTrack:function(val){
					if(this.moveFlag){
						this.moveByRail(val)//根据时间轴所代表时间让车在轨迹上移动
					}
			},
			'vehiInfo.uni'(val){
				if(this.clearTheOld){
					this.map.clearOverlays()
				}
				if(this.mapShowType === 1){//查看定位点
					const obj = {
						posiInfo:this.locateInfo,
						vehiInfo:this.vehiInfo
					}
					//1，将地图中心点移到车辆定位点
					this.mapCenter = {lng:Number(this.locateInfo.lngBd),lat:Number(this.locateInfo.latBd)}
					this.setVehicleToMap(obj)
				} else if (this.mapShowType === 10) {
					// 绘制救援轨迹
					this.drawRescueTrace(this.vehiInfo, this.trackInfoList);
				}else{
					const that = this
					if(this.mapShowType === 2){//报警现场->画轨迹->显示报警点->画报警区域
						//2，显示报警点
						this.almPosi = {
							lng:this.almInfoObj.almLng,
							lat:this.almInfoObj.almLat
						}
						this.showAlmPosi(that.almInfoObj.almLng,that.almInfoObj.almLat)
						//3，画报警现场
						if(this.almInfoObj.almPoints != ''){//报警区域坐标不为空
							let pointsArr = JSON.parse(this.almInfoObj.almPoints)
							this.drawAlarmArea(pointsArr)
						}
					}
					this.drawTrace(that.vehiInfo);//画轨迹线以及添加起点、终点、停车、报警标注
				}
			}
		},
		mounted() {
			this.mapStyle.height = $('#content-main').height() + 'px';
			const that = this;
			window.onresize = function temp() {
		    	that.mapStyle.height = $('#content-main').height() + 'px'; 
		    }; 
		},
		destroyed(){
			//初始化
			this.map.clearOverlays()
			this.$store.dispatch('initMap')
		},
		methods:{
			ready(obj) {//初始化地图并添加了控件
				const { BMap, map } = obj;		
				this.BMap = BMap;
				this.map = map;
				/*this.right = map.getBounds().getSouthWest().lng;		
				const zoom = this.mapZoom;
				const scaleDiff = switchZoomToScale(zoom)
				this.right +=  240 / scaleDiff;	
				map.panBy(this.right,0);*/
				map.enableScrollWheelZoom();//启动滚轮放大缩小
				map.addControl(new BMap.ScaleControl({offset:new BMap.Size(250,120)}));//比例尺控件
			},	
			setVehicleToMap(val){//添加车辆定位点
				let posiInfo = val.posiInfo
				let vehiInfo = val.vehiInfo
				const point = {
					lng:Number(posiInfo.lngBd),
					lat:Number(posiInfo.latBd)
				}
				const {BMap} = this;
				this.addCarMarker(posiInfo,point,vehiInfo.vInfo)
				this.$store.dispatch('loadingFinish')
				let obj = this.railArr.find(n=>n.info==vehiInfo.vId)
				this.railArr.push({marker:this.carMarker,info:vehiInfo.vId})
			},
			showAlmPosi(lng,lat){//显示报警点
				const {map,BMap} = this;
				const almPoint = new BMap.Point(lng,lat)
				this.almMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_23,almPoint,map,BMap,'警')
			},
			drawAlarmArea(points){//画报警现场
				const {map,BMap} = this;
				//绘制多边形-报警区域
				let polygon = new BMap.Polygon(points);
				map.addOverlay(polygon)
				this.polyOverlay = polygon
			},
			drawTrace(vehiInfo){//画轨迹线和停车点
				const {map,BMap} = this;
				const that = this;
				this.setCity(vehiInfo.vInfo)
				for(let i = 0, length = this.travels.length; i < length; i ++){	
					this.drawLine(that.travels[i],BMap)
				}
				this.railArr.push({
						overlay:this.polyArr,
						info:vehiInfo.vId,
						carM:this.carMarker,
						startM:this.startMarker,
						endM:this.endMarker,
						almM:this.almMarker,
						plg:this.polyOverlay,
						stopMs:this.stopMkArr
				})
				this.temPoint = []
				this.polyArr = []
			},
			//绘制救援轨迹
			drawRescueTrace(vehiInfo, gpsList){
				const {map,BMap} = this;
				
				const val = this.trackInfoList;
				const length = this.trackInfoList.length;				
				let startPoint = new BMap.Point(val[0].lngBd,val[0].latBd)
				map.setCenter(startPoint)
				let endPoint = new BMap.Point(val[length - 1].lngBd,val[length - 1].latBd)
				this.startMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_21,startPoint,map,BMap,'起')
				// 点击，显示在最上层
				this.startMarker.addEventListener("click",()=>{
					this.startMarker.setTop(true)
					this.endMarker.setTop(false)
				});
				// 鼠标移入，信息框显示
				this.startMarker.addEventListener("mouseover",()=>{
					this.startMarker.getLabel().show();
					this.labelCatched.show();
				});
				// 鼠标移出，信息框隐藏
				this.startMarker.addEventListener("mouseout",()=>{
					this.startMarker.getLabel().hide();
					this.labelCatched.hide();
				});
				this.endMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_24,endPoint,map,BMap,'终')
				this.endMarker.addEventListener("click",()=>{
					this.startMarker.setTop(false)
					this.endMarker.setTop(true)
				});
				this.endMarker.addEventListener("mouseover",()=>{
					this.endMarker.getLabel().show();
				});
				this.endMarker.addEventListener("mouseout",()=>{
					this.endMarker.getLabel().hide();
				});
				this.addCarMarker(val[0],startPoint,vehiInfo)
				
				this.carMarker.getLabel().hide();
				this.setLabel(this.startMarker, this.endMarker);
				let blueArr = [];
				let redArr = [];
				let blueLine = {strokeColor:"#2B97F0", strokeWeight:6, strokeOpacity:0.8};
				let redLine = {strokeColor:"#F23F3C", strokeWeight:6, strokeOpacity:0.8};
				let currAv = "1";
				gpsList.forEach((item, index) => {
					let curPoint = new BMap.Point(item.lngBd,item.latBd);
					if(item.av == "1"){
						blueArr.push(curPoint)
					} else if (item.av == "2"){
						redArr.push(curPoint)
					}
					if(item.av != currAv){
						let targetMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_25,curPoint,map,BMap,'拖')
						currAv = "2";
						// 设置救援点的label
						let labelTarget = new BMap.Label(this.getLabelContent("target"));
						if(this.getLabelContent("target")){
							labelTarget.setOffset(new BMap.Size(0, -70));
							labelTarget.setStyle({
								border: 'none',
								background: 'none',
								bottom: '5px'
							});
							targetMarker.setLabel(labelTarget);
							this.targetMarker = targetMarker;
							this.targetMarker.getLabel().hide();
							this.targetMarker.addEventListener("mouseover",()=>{
								this.targetMarker.getLabel().show();
							});
							this.targetMarker.addEventListener("mouseout",()=>{
								this.targetMarker.getLabel().hide();
							});
						}
					}
				});
				if(redArr.length == 0){
					// 设置救援点的label
					let labelTarget = new BMap.Label(this.getLabelContent("target"));
					if(this.getLabelContent("target")){
						labelTarget.setOffset(new BMap.Size(0, -70));
						labelTarget.setStyle({
							border: 'none',
							background: 'none',
							bottom: '5px'
						});
						this.endMarker.setLabel(labelTarget);
						labelTarget.hide();
					}
				} else {
					blueArr.push(redArr[0]);
				}
				let bluePolyline = new BMap.Polyline(blueArr, blueLine);
				let redPolyline = new BMap.Polyline(redArr, redLine);
				map.addOverlay(bluePolyline);
				map.addOverlay(redPolyline);
				
				this.polyArr.push(bluePolyline)
				this.polyArr.push(redPolyline)
				
				const startP = gpsList[0];
				const endP = gpsList[gpsList.length - 1]
				map.setViewport([new BMap.Point(startP.lngBd,startP.latBd),new BMap.Point(endP.lngBd,endP.latBd)])
//				map.zoomOut();
				
				this.railArr.push({
					overlay:this.polyArr,
					info:vehiInfo.vId,
					carM:this.carMarker,
					startM:this.startMarker,
					endM:this.endMarker,
					targetM:this.targetMarker
				})
			},
			getLabelContent(target) {
				/*
				    21-司机已接单
					23-现场已到达
					31-救援完成
					60-获取客户联系方式
				 */
				let content;
				let contentStr;
				// 已接单
				if(target == "catched"){
					let item = this.rescueEventList.find(item => item.id == 21);
					if(!item) return undefined;
					contentStr = item.av;
					content = `
						<div class="car_info_box_picc02 car_info">
							<dl>
								<dt class="dt_text">
								    <i>${contentStr}</i>
								</dt>
							</dl>
						</div>`
				} else if(target == "phone") {
					let item1 = this.rescueEventList.find(item => {
						console.log(item.id);
						return item.id == 60;
					});
					if(!item1) return undefined;
					contentStr = item1.av;
					// 查看联系方式
					content = `
						<div class="car_info_box_picc03 car_info">
							<dl class="w200px">
								<dt class="dt_text">
								    <i>${contentStr}</i>
								</dt>
							</dl>
						</div>`
				} else if(target == "target") {
					// 2017-09-07 09:44:22到达@现场#现场行程1601.9公里耗时9小时44分
					let item2 = this.rescueEventList.find(item => item.id == 23);
					if(!item2) return undefined;
					contentStr = item2.av;
					let orderId1 = item2.directionName;
					let time1 = contentStr.split("@")[0];
					let spendDistance1 = contentStr.split("#")[1];
					// 到达现场
					content = `
						<div class="car_info_box_picc02 car_info">
							<dl>
								<dt class="dt_text">
								    <i>${time1}<em>${orderId1}</em>现场</i>
								    <i>${spendDistance1}</i>
								</dt>
							</dl>
						</div>`
				} else if(target == "complete") {
					// 2017-08-23 23:59:59@救援完成#总耗时23小时59分(现场9小时44分|目的地9小时44分)#1601.9公里(现场1601.9公里|目的地263米)
					let item3 = this.rescueEventList.find(item => item.id == 31);
					if(!item3) return undefined;
					contentStr = item3.av;
					let orderId = item3.directionName;
					let time = contentStr.split("@")[0];
					let spendTimeStr = contentStr.split("#")[1];
					let spendDistance = contentStr.split("#")[2];
					// 完成救援
					content = `
						<div class="car_info_box_picc03 car_info">
							<dl>
								<dt class="dt_text">
								    <i>${time} <em> ${orderId} </em>救援完成</i>	
									<i>${spendTimeStr}</i>
									<i>${spendDistance}</i>
								</dt>
							</dl>
						</div>`
				}
				return content;
			},
			setLabel(startMarker, endMarker){
				// 已接单label
				let labelCatched = new BMap.Label(this.getLabelContent("catched"));
				this.labelCatched = labelCatched;
				if(this.getLabelContent("catched")){
					labelCatched.setOffset(new BMap.Size(0, -25));
					labelCatched.setStyle({
						border: 'none',
						background: 'none',
						bottom: '5px'
					});
					startMarker.setLabel(labelCatched)
					labelCatched.hide();
				}
				// 查看联系方式label
				let labelPhone = new BMap.Label(this.getLabelContent("phone"));
				if(this.getLabelContent("phone")){
					labelPhone.setOffset(new BMap.Size(0, 55));
					labelPhone.setStyle({
						border: 'none',
						background: 'none',
						bottom: '5px'
					});
					startMarker.setLabel(labelPhone)
					labelPhone.hide();
				}
				
				// 完成救援label
				let labelComplete = new BMap.Label(this.getLabelContent("complete"));
				if(this.getLabelContent("complete")){
					labelComplete.setOffset(new BMap.Size(0, 55));
					labelComplete.setStyle({
						border: 'none',
						background: 'none',
						bottom: '5px'
					});
					endMarker.setLabel(labelComplete);
					labelComplete.hide();
				}
			},
			setCity(vehiInfo){//切换到相应城市后添加起点、终点、停车等标注
				const {map,BMap} = this;
				const val = this.trackInfoList;
				const length = this.trackInfoList.length;				
				let startPoint = new BMap.Point(val[0].lngBd,val[0].latBd)
				map.setCenter(startPoint)
				let endPoint = new BMap.Point(val[length - 1].lngBd,val[length - 1].latBd)
				this.startMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_21,startPoint,map,BMap,'起')
				this.endMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_24,endPoint,map,BMap,'终')
				if(this.stopIndex.length != 0){
					this.stopMkArr = []
					for(let i = 0, length = this.stopIndex.length; i < length; i++){
						const index = this.stopIndex[i]
						let stopMarker = {}
						if(this.mapShowType == 2 && val[index].lngBd == this.almPosi.lng && val[index].latBd == this.almPosi.lat){
							continue
						}
						let stopPoint = new BMap.Point(val[index].lngBd,val[index].latBd);
						stopMarker = this.addSEPoint(VEHICLE_TRACK.tip_icon_22,stopPoint,map,BMap,'停')
						this.stopMkArr.push(stopMarker)
					}
				}
				this.addCarMarker(val[0],startPoint,vehiInfo)
				
			},
			moveByRail(val){ //根据时间轴所代表时间让车在轨迹上移动
			    let	point = new BMap.Point(val.lngBd,val.latBd)
			 	const self = this;
			 	if(this.vehiInfo.showCarType && this.vehiInfo.showCarType === 1){
					this.carIconName = this.getTrailerName(val);
				} else {
					this.carIconName = this.getPicName(val);		
				}
				this.carIcon.setImageUrl(this.getPicUrl(self.carIconName));//更改小车图片
				this.carMarker.setIcon(this.carIcon);
			    this.carMarker.setPosition(point);
				this.carMarker.setLabel(this.carLabel);	
				
				const { map } = this;
				if(!map.getBounds().containsPoint(point)){
					map.panTo(point,{noAnimation:true});
				}
			},
			addCarMarker(gpsInfo,point,vehiInfo){//gpsInfoList	
				const {BMap} = this;
				var that = this;
				if(this.vehiInfo.showCarType && this.vehiInfo.showCarType === 1){
					this.carIconName = this.getTrailerName(gpsInfo);
				} else {
					this.carIconName = this.getPicName(gpsInfo);		
				}
				this.carIcon = new BMap.Icon(this.getPicUrl(that.carIconName),new BMap.Size(33,33));
				this.carMarker = new BMap.Marker(point,{icon:this.carIcon});
				this.carLabel = new BMap.Label('<p>' + vehiInfo.vehicleNum + '  ' + vehiInfo.plateNumber+ '</p>')
				this.carLabel.setOffset(new BMap.Size(33,-4))
				this.carLabel.setStyle({borderColor:'#000'});
				this.carMarker.setLabel(this.carLabel);
				this.map.addOverlay(this.carMarker);
			},
			drawLine(val,BMap){//画轨迹线
				const that = this;
				for(let i = 0, length = val.length; i < length; i++){
					if(val[i].lngBd !== null && val[i].latBd !== null){
						const points1 = new BMap.Point(val[i].lngBd,val[i].latBd)
						this.temPoint.push(points1);
						if(i == val.length - 1){//最后一个gps坐标点
							if(this.temPoint.length > 1){
								this.setPolylineColor(val[i].speed,that.temPoint);
								this.temPoint.splice(0,that.temPoint.length);
							}
							break;
						}
						if(val[i + 1].lngBd != null && val[i + 1].latBd != null){
							//根据速度画出轨迹线----轨迹按照速度区间分段--能不能形成线段，要判断当前点的下一个点
							this.drawPolyline(val[i],val[i+1]);
						}
					}
				}
			},
			drawPolyline:function(obj1,obj2){//根据速度画出轨迹线（用颜色区分不同速度下的轨迹线）
				const {BMap} = this
				const that = this;
				if(obj1.speed <= 60){//当速度小于60
					const oSpeed1 = parseInt(obj1.speed/20);
					const oSpeed2 = parseInt(obj2.speed/20);
					if(oSpeed1 != oSpeed2){//分别是20或40或60
						this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));
						this.setPolylineColor(obj1.speed,that.temPoint);
						this.temPoint.splice(0,this.temPoint.length)										
					}
				}else if(obj1.speed <= 120){				
					if(obj2.speed <= 60 || obj2.speed > 120){									
							this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));		
							this.setPolylineColor(obj1.speed,that.temPoint);
							this.temPoint.splice(0,this.temPoint.length);	
						}
									
				}else{
						if(obj2.speed <= 120){
							this.temPoint.push(new BMap.Point(obj2.lngBd,obj2.latBd));
							this.setPolylineColor(obj1.speed,that.temPoint);
							this.temPoint.splice(0,this.temPoint.length);
						}
				}
			},
			setPolylineColor:function(startSpeed,points){//设置轨迹线颜色
				let polylineArr = []
				const {map,BMap} = this;
//				var _color20 = {strokeColor:"#DF0101", strokeWeight:6, strokeOpacity:0.8};
//			    var _color40 ={strokeColor:"#FD9725", strokeWeight:6, strokeOpacity:0.8};
//			    var _color60 = {strokeColor:"#A5DF00", strokeWeight:6, strokeOpacity:0.8};
//			    var _color120 = {strokeColor:"#31B404", strokeWeight:6, strokeOpacity:0.8};
//			    var _color120max = {strokeColor:"#0040FF", strokeWeight:6, strokeOpacity:0.8};
			    var _color20 = {strokeColor:"#0040FF", strokeWeight:6, strokeOpacity:0.8};
			    var _color40 ={strokeColor:"#31B404", strokeWeight:6, strokeOpacity:0.8};
			    var _color60 = {strokeColor:"#A5DF00", strokeWeight:6, strokeOpacity:0.8};
			    var _color120 = {strokeColor:"#FD9725", strokeWeight:6, strokeOpacity:0.8};
			    var _color120max = {strokeColor:"#DF0101", strokeWeight:6, strokeOpacity:0.8};
			    var polyline;
		    	if(parseFloat(startSpeed) <= 20){
		    		polyline= new BMap.Polyline(points, _color20);
		    	}else if(parseFloat(startSpeed) <= 40){
		    		polyline= new BMap.Polyline(points, _color40);
		    	}else if(parseFloat(startSpeed) <= 60){
		    		polyline= new BMap.Polyline(points, _color60);
		    	}else if(parseFloat(startSpeed) <= 120){
		    		polyline= new BMap.Polyline(points, _color120);
		    	}else {
		    		polyline= new BMap.Polyline(points, _color120max);
		    	}
				map.addOverlay(polyline);
				this.polyArr.push(polyline)
			}
		}
	}

	  //设置车辆状态
	function getCarState(data) {
		if(data.status.indexOf('离线') >= 0){
		    data.status = '离线';
		} else if(data.status.indexOf("行驶")>=0) {
		    var speed = data.speed;
			if(speed<5){
			    data.status = "停车";
			}else{
			    data.status = "行驶";
			}
		}
		return data.status;
	}
//转换后台所传时间的格式
function switchTime(gpstime){
	return '20' + gpstime.substring(0,2)
				+ '-' + gpstime.substring(2,4)
				+ '-' + gpstime.substring(4,6)
				+ ' ' + gpstime.substring(6,8)
				+ ':' + gpstime.substring(8,10)
				+ ':' + gpstime.substring(10);
}
	function switchZoomToScale(zoom){
		let scale = 500
		switch(zoom){
			case 18:
				scale = 50
				break;
			case 17:
				scale = 100
				break;	
			case 16:
				scale = 200
				break;
			case 15:
				scale = 500
				break;
			case 14:
				scale = 1000
				break;
			case 13:
				scale = 2000
				break;	
			case 12:
				scale = 5000
				break;
			case 11:
				scale = 10000
				break;	
			case 10:
				scale = 20000
				break;	
		}
		return scale;
	}
</script>

<style scoped>
.trackMap{
	-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;cursor:pointer;
}
</style>


// WEBPACK FOOTER //
// TrackMap.vue?fd87bb7c